export const EH_ADMIN_ROLES = {
    SuperAdministrator: {
        id: 1,
        name: 'Super Administrator'
    },
    SystemAdministrator: {
        id: 2,
        name: 'System Administrator'
    }
}

export const CUSTOMER_ROLES = {
    Owner: {
        id: 1,
        name: 'Owner'
    },
    Moderator: {
        id: 2,
        name: 'Moderator'
    },
    Admin: {
        id: 3,
        name: 'Administrator'
    },
    User: {
        id: 4,
        name: 'User'
    }
}

export const allRoleNames = [
    CUSTOMER_ROLES.User.name,
    CUSTOMER_ROLES.Admin.name,
    CUSTOMER_ROLES.Moderator.name,
    CUSTOMER_ROLES.Owner.name,
    EH_ADMIN_ROLES.SuperAdministrator.name,
    EH_ADMIN_ROLES.SystemAdministrator.name
]

